import conf from 'configuration.json';
import cookie from 'react-cookies'
import RequestBuilder from 'common/RequestBuilder';

export function handleError (error) {
    let formData = new FormData();
    formData.append("errorInfo", error.toString());
    formData.append("supportToken", cookie.load('support_token'));
    new RequestBuilder('post', conf.rest.logErrorEndpoint).params(formData).send(()=>{});
}


// WEBPACK FOOTER //
// ./src/common/ErrorHandler.js